export default __webpack_public_path__ + "static/media/Pubblico alla premiazione.7dfb90a5.jpg";